// cache_controller.js
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['page'];

  cachePages() {
    const selectedPages = this.pageTargets.filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.value);

    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        action: 'cachePages',
        pages: selectedPages,
      });
    }
  }

  connect() {
    console.log('cache controller connected');
    console.log(this.pageTargets);
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data.action === 'cacheComplete') {
        console.log('Selected pages have been cached for offline use.');
      }
    });
  }
}
